export default [
    {
        "data": [
            {
                "cross_section": "43827"
            },
            {
                "cross_section": "42157"
            }
        ],
        "error_id": "NR-01"
    },
    {
        "data": [
            {
                "cross_section": "44000"
            },
            {
                "cross_section": "42400"
            },
            {
                "cross_section": "42200"
            }
        ],
        "error_id": "NR-02"
    },
    {
        "data": [
            {
                "cross_section": "42200",
                "base": {
                    "cross_section": "42210",
                    "lob": 0.15,
                    "rob": 0.131,
                    "chn": 0.045
                },
                "cmp": {
                    "lob": 0.131,
                    "rob": 0.13,
                    "chn": 0.045
                }
            }
        ],
        "error_id": "NR-03"
    },
    {
        "data": [
            {
                "cross_section": "42127 BR U"
            },
            {
                "cross_section": "42127 BR D"
            }
        ],
        "error_id": "NR-ICS-01"
    }
]